import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { BsX } from 'react-icons/bs'

import { navigationHideModal } from 'action/navigation'

import ButtonStandard from 'view/component/generic/input/button-standard'

class RequestErrorModal extends React.Component {
  render () {
    return (
      <div className='d-flex flex-column p-2'>
        <div className='d-flex'>
          <h5 className='d-flex align-items-center flex-grow-1 m-0'>Request Error!</h5>
          <ButtonStandard onClick={this.props.handleHideModal} tertiary><BsX size='2rem' /></ButtonStandard>
        </div>
        <div className='d-flex justify-content-between align-items-center flex-grow-1 pt-3'>
          <span className='py-2 pr-2 w-100'>{this.props.errorMessage}</span>
        </div>
        <div className='d-flex justify-content-between align-items-center flex-grow-1 pt-3'>
          <ButtonStandard containerClassname='w-100' className='p-2 w-100' onClick={this.props.handleHideModal} primary>Ok</ButtonStandard>
        </div>
      </div>
    )
  }
}

export default connect(state => ({
}), dispatch => ({
  handleHideModal: bindActionCreators(navigationHideModal, dispatch)
}))(RequestErrorModal)
